// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XnBFv","col":"styles_col__1-fqD"};